import axios from 'axios';

import { REPORTES } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const filtrarIngresosEgresos = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_INGRESOS_EGRESOS,
        payload: opcion
    });
}

export const filtrarVentasMedicos = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_VENTAS_MEDICOS,
        payload: opcion
    });
}

export const filtrarVentasDiarias = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_VENTAS_DIARIAS,
        payload: opcion
    });
}

export const filtrarVentasDetalle = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_VENTAS_DETALLE,
        payload: opcion
    });
}

export const filtrarVentasUnidades = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_VENTAS_UNIDADES,
        payload: opcion
    });
}

export const filtrarLineasVenta = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_LINEAS_VENTA,
        payload: opcion
    });
}

export const filtrarOrdenesItems = (opcion) => dispatch => {
    dispatch({
        type: REPORTES.FILTROS_ORDENES_ITEMS,
        payload: opcion
    });
}

export const generarIngresosEgresos = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ingresos_egresos`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_ingresos_y_egresos.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error.response.data.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}

export const generarVentasMedicos = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ventas_medicos`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_ventas_por_medicos.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error.response.data.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}

export const generarVentasDiarias = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ventas_diarias`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_totalizacion_ventas_diarias.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error.response.data.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}

export const generarVentasDetalle = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ventas_detalle`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_ventas.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error.response.data.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}

export const generarVentasUnidades = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ventas_unidades`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_unidades_vendidas.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error.response.data.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}

export const generarLineasVenta = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/lineas_venta`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);
        
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_detalle_lineas_venta.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}

export const generarOrdenesItems = (datos) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        },
        responseType: 'blob'
    }

    const body = JSON.stringify(datos);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ordenes_items`, body, config);
        await dispatch(changeLoader(false));

        const file = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', 'Reporte_ordenes_items.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        dispatch(setAlert('Reporte generado correctamente', 'success'));

    } catch (error) {
        await dispatch(changeLoader(false));

        if (error?.response?.data?.errors) {
            error.response.data.errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
    }
}